import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_REPRESENTATIVES_QUERY = queryWithFallbackKey(
    gql`
        query getRepresentativesListing($defaultLanguage: String!) {
            getObjectFolder(
                fullpath: "/Contacts/Representatives"
                defaultLanguage: $defaultLanguage
            ) {
                children {
                    ... on object_Representative {
                        id
                        key
                        name
                        phone
                        email
                        salesAddressLine1
                        salesAddressLine2
                        salesAddressLine3
                        countryOrSubnational {
                            ... on object_Country {
                                id
                            }
                            ... on object_SubnationalRegion {
                                id
                            }
                        }
                        logo {
                            fullpath
                        }
                        text
                    }
                }
            }
        }
    `,
    'GET_REPRESENTATIVES_QUERY'
);

export function getRepresentativesQueryVariables(localeCode: LocaleCode) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
    };
}
